import { AdvancedImage } from "@cloudinary/react";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { FilterMatchMode } from "primereact/api";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { Link } from "react-router-dom";
import useUnfavorite from "../../../../hooks/useUnfavorite";
import localeText from "../../../../locale";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import "../StatementTable/StatementTable.css";
import "../UserDashboardHome/UserDashboardHome.css";
import { Button } from "primereact/button";
import { formatPrice } from "../../../../utilities/formatPrice";
import { PLATFORM_PRODUCT_FEE } from "../../../../utilities/constants";

const FavoritedProducts = () => {
  const { isLoading, products, isLoadingUnfavoriting, unfavoriteProduct } = useUnfavorite();
  const toast = useRef(null);

  const filters2 = {
    title: { value: null, matchMode: FilterMatchMode.CONTAINS },
    "product.product.user.username": { value: null, matchMode: FilterMatchMode.CONTAINS },
  };

  return (
    <div className="card border-1 border-300">
      <Toast ref={toast} />

      <h3 className="my-4">{localeText("products")}</h3>
      <hr />

      <DataTable
        className="mt-4 mb-6 p-datatable-customers"
        value={products}
        paginator
        responsiveLayout="scroll"
        loading={isLoading || isLoadingUnfavoriting}
        dataKey="id"
        filters={filters2}
        filterDisplay="row"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate={localeText("showingFirstToLast")}
        rows={10}
        rowsPerPageOptions={[10, 20, 50]}
      >
        <Column
          header={localeText("productImage")}
          body={(product) => {
            return (
              <Link to={`/product?id=${product.product.id}`}>
                <AdvancedImage
                  cldImg={cloudinaryInstance
                    .image(product.product.imageid1)
                    .resize(fill().width(600).height(600))
                    .format("webp")}
                  height={75}
                  style={{ border: "1px solid #E0E0E0" }}
                  className="border-round product-thumbnail"
                />
              </Link>
            );
          }}
          style={{ width: "10%" }}
        />
        <Column
          field="product.title"
          header={localeText("title")}
          style={{ width: "25%" }}
          filter
          filterPlaceholder={localeText("searchByTitle")}
          filters={filters2}
          filterDisplay="row"
          sortable
        />
        <Column
          field="product.user.username"
          header={localeText("seller")}
          style={{ width: "15%" }}
          filter
          filterPlaceholder={localeText("searchBySeller")}
          filters={filters2}
          filterDisplay="row"
          sortable
        />
        <Column
          field="product.priceUnique"
          sortable
          header={localeText("price")}
          body={(product) => {
            const { currency, promotionalPriceUnique, priceUnique } = product.product;
            const priceWithFEE = promotionalPriceUnique
              ? promotionalPriceUnique + PLATFORM_PRODUCT_FEE * promotionalPriceUnique
              : priceUnique + priceUnique * PLATFORM_PRODUCT_FEE;

            return (
              <p>
                {currency} {formatPrice(priceWithFEE)}
              </p>
            );
          }}
          style={{ width: "15%" }}
        />
        <Column
          header={localeText("productState")}
          body={(product) => {
            return (
              <>
                {product.product.stateofproduct === "NEW" && <span>{localeText("new")}</span>}
                {product.product.stateofproduct === "USED" && <span>{localeText("used")}</span>}
              </>
            );
          }}
          style={{ width: "8%" }}
        />
        <Column
          field="product.amountInStock"
          header={localeText("stock")}
          style={{ width: "8%" }}
        />
        <Column
          header={localeText("unfavorite")}
          body={(product) => (
            <Button
              icon={<i className="pi pi-times-circle" />}
              onClick={() => unfavoriteProduct(product.product.id)}
              severity="danger"
            ></Button>
          )}
          style={{ width: "10%" }}
        />
      </DataTable>
    </div>
  );
};

export default FavoritedProducts;
